/** A module of its own so tests can stand in for it: jsdom can't reload. */
export function reloadPage(): void {
    window.location.reload();
}
